import React from "react";
import { NavLink } from "react-router-dom";
import { FaCalendarCheck } from "react-icons/fa6";
import { motion } from "framer-motion";
import { easing } from "../utils/motionVariants";
import "./Navbar.css";

const NAV_LINKS = [
  { to: "/home", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/experience", label: "Experience" },
  { to: "/skills", label: "Skills" },
  { to: "/portfolio", label: "Projects" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar({ onCalendlyClick = () => {} }) {
  const [isSticky, setIsSticky] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.header
      className={`nav-shell ${isSticky ? "sticky" : ""}`}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: easing }}
    >
      <NavLink to="/home" className="nav-brand" aria-label="Go to home">
        <motion.span
          className="brand-mark"
          whileHover={{ rotate: -8, scale: 1.06 }}
          transition={{ duration: 0.3, ease: easing }}
        >
          <img src="/logo192.png" alt="Hirun Kolongahapitiya logo" />
        </motion.span>
        <div className="brand-copy">
          <p className="brand-eyebrow">Hirun Kolongahapitiya</p>
          <small>Software Engineer</small>
        </div>
      </NavLink>

      <nav className="nav-links" aria-label="Primary">
        {NAV_LINKS.map(({ to, label, end }, idx) => (
          <motion.div
            key={to}
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 + idx * 0.05, duration: 0.35, ease: easing }}
            whileHover={{ y: -2 }}
          >
            <NavLink to={to} end={end} className={({ isActive }) => (isActive ? "active" : "")}>
              {label}
            </NavLink>
          </motion.div>
        ))}
      </nav>

      <div className="nav-actions">
        <motion.button
          type="button"
          className="nav-cta"
          onClick={onCalendlyClick}
          whileHover={{ scale: 1.05, y: -2 }}
          whileTap={{ scale: 0.96 }}
          transition={{ duration: 0.2, ease: easing }}
        >
          <FaCalendarCheck />
          <span>Schedule a call</span>
        </motion.button>
      </div>
    </motion.header>
  );
}
